"use strict";
exports.__esModule = true;
var parseUrl = require("url-parse");
var types_1 = require("../../types");
exports.DEFAULT_PORT = 14265;
exports.DEFAULT_HOST = 'http://localhost';
exports.DEFAULT_URI = exports.DEFAULT_HOST + ":" + exports.DEFAULT_PORT;
exports.REQUEST_BATCH_SIZE = 1000;
exports.API_VERSION = 1;
var defaults = {
    provider: exports.DEFAULT_URI,
    requestBatchSize: exports.REQUEST_BATCH_SIZE,
    apiVersion: exports.API_VERSION
};
/* tslint:disable no-console */
exports.getSettingsWithDefaults = function (settings) {
    if (settings === void 0) { settings = {}; }
    var _a = types_1.getOptionsWithDefaults(defaults)(settings), provider = _a.provider, host = _a.host, port = _a.port, user = _a.user, password = _a.password, sandbox = _a.sandbox, token = _a.token, requestBatchSize = _a.requestBatchSize, apiVersion = _a.apiVersion;
    var providerUri = provider;
    if (sandbox || token) {
        throw new Error('Sandbox has been removed in favor of a more generic remote curl machine, a.k.a. powbox. See NPM package @iota/curl-remote for details.');
    }
    // Check for deprecated settings
    if (host || port) {
        console.warn('Setting `host` and `port` is deprecated and will be removed in next version. Please use the `provider` option instead.');
        providerUri = [host || exports.DEFAULT_HOST, port || exports.DEFAULT_PORT].join('/').replace('//', '/');
    }
    if (user && password && parseUrl(providerUri, true).protocol !== 'https:') {
        throw new Error('Basic auth requires https.');
    }
    if (settings.hasOwnProperty('requestBatchSize')) {
        if (!Number.isInteger(requestBatchSize) || requestBatchSize <= 0) {
            throw new Error('Invalid `requestBatchSize` option');
        }
    }
    return { provider: providerUri, requestBatchSize: requestBatchSize, apiVersion: apiVersion, user: user, password: password };
};
//# sourceMappingURL=settings.js.map